export const ALL_PROJECTS_OPTION = 'all';
export const OCTO_GLOBAL_PERMISSIONS = {
    MANAGE: 'octo-jexo-component-management__manage-components-octo',
    VIEW: 'octo-jexo-component-management__view-components-octo',
};
export const ERROR_CODES = {
    SYNC_IN_PROGRESS: 'sync_in_progress',
    IMPORT_IN_PROGRESS: 'import_in_progress',
    EDIT_IN_POGRESS: 'edit_in_progress',
};

export const SYNC_ERRORS_MESSAGES = {
    sync_in_progress: {
        message: `Another synchronization process is already in progress. Please wait until it's done and try again.`,
        title: 'Synchronization in progress...',
    },
    import_in_progress: {
        message: `An import components process(which calls sync process) is already in progress. Please wait until it's done and try again.`,
        title: 'Import components in progress...',
    },
    edit_in_progress: {
        message: `An edit components process is already in progress. Please wait until it's done and try again.`,
        title: 'Editing components in progress...',
    },
};
export const COMPONENT_HIERARCHY_TYPES = {
    COMPONENT: 'component',
    LABEL: 'label',
};

export const RED = '#DE350B';
export const GREEN = '#00875A';

export const ISSUE_STATUS_CATEGORY_IDS = Object.freeze({
    IN_PROGRESS: 4,
    TO_DO: 2,
    DONE: 3,
});

export const ISSUE_STATUS_CATEGORY_IDS_BY_KEY = Object.freeze({
    indeterminate: 4,
    new: 2,
    done: 3,
});
